import type { ILocation } from '~/types/location/models'
import { Address } from '~/cynqueModules/dataObjects/Address'
import { LocationCompanyContact } from '~/cynqueModules/dataObjects/LocationCompanyContact'
import { formatDollars } from '~/cynqueModules/formatDollars'

export function Location(o: ILocation): ILocation {
  const fn = '[cynqueModules/dataObjects/Location.ts] Location |'
  if (!o) {
    throw new Error(`${fn} Location called with falsey location`)
  }

  const obj = { ...o }
  if (obj.address) {
    obj.address = Address(obj.address)
  }
  obj.primaryLcon = obj.primaryLcon
    ? LocationCompanyContact(obj.primaryLcon)
    : undefined
  obj.secondaryLcon = obj.secondaryLcon
    ? LocationCompanyContact(obj.secondaryLcon)
    : undefined

  obj.nickNamePlusAddressLine1Descr =
    obj.nickname.toLocaleUpperCase() +
    (obj.nickname ? ' ... ' : '') +
    obj.address?.addressLine1

  obj.addressPlusMainPhoneDescr =
    (obj.address?.descr ?? '') + (obj.mainPhone ? '\n' + obj.mainPhone : '')

  obj.cityStateZipPlusMainPhoneDescr =
    (obj.address?.cityStateZip ?? '') +
    (obj.mainPhone ? '\n' + obj.mainPhone : '')

  obj.costCenterPlusSpendDescr =
    (obj.costCenter ?? '') +
    (obj.spend != null ? '\n' + formatDollars(obj.spend) : '')

  obj.cableCompanyPlusLecDescr =
    (obj.cableCompany ?? '') + (obj.lec ? '\n' + obj.lec : '')

  // console.debug(`${fn} returning`, obj)
  return obj
}
